import React, {useState} from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Button,
} from '@material-ui/core';

import {
  LatestInternships,
  Stats,
  CreateOffer
} from './components/';

import { getMyOffers } from 'utils/requests'
import PropTypes from "prop-types";
import ProductList from "../Offers";

let isLoading = true;

function useForceUpdate(){
  const [value, setValue] = useState(0); // integer state
  return () => setValue(value => ++value); // update the state to force render
}

const getOffers = async (forceUpdate, history) =>{
  if(isLoading){
  return getMyOffers(history)
    .then((res) => {
      if(res){
        // console.log(res)
        isLoading = false;
        my_offers = res
        forceUpdate();
      } else{
        alert('An arror happened while fetching for data');
      }
    })
  }
}

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  }
}));

let my_offers

const MyOffers = (props) => {
  const forceUpdate = useForceUpdate();
  const { history } = props;
  getOffers(forceUpdate, history);

  // console.log(my_offers)
  const classes = useStyles();

  return (
    <div>
      {!isLoading && 
    <div className={classes.root}>
      <Grid
        container
        spacing={4}
      >

        <Grid
          item
          lg={8}
          sm={8}
          xl={8}
          xs={12}
        >
          <LatestInternships data={my_offers} history={history}/>
        </Grid>

        <Grid
          item
          lg={4}
          sm={4}
          xl={4}
          xs={12}
        >
          <Card>
            <CardHeader
              subheader="Create a new offer"
              title="Create a new offer" />
            <CardContent>
             <CreateOffer />
            </CardContent>
          </Card>

          <Card>
                <Stats data={my_offers}/>
          
          </Card>

        </Grid>

      </Grid>
    </div>
    }
    </div>
  );
};


MyOffers.propTypes = {
  history: PropTypes.object
};

export default MyOffers;
